// extracted by mini-css-extract-plugin
export default {"home":"App_home__5V9aF","content":"App_content__naSmy"};